export type DisneyPromoCountries = (typeof CountriesAvailable)[number];
export const CountriesAvailable = ['DK', 'NO', 'SE'] as const;

type DisneyPromoTexts = Record<DisneyPromoCountries, PromoTexts>;
const PromotionTexts: DisneyPromoTexts = {
	DK: {
		ribbon: 'SALE',
		offerText: '19 kr./md.',
		longText: 'Særtilbud: 19 kr./måned',
		endDate: '2024-03-14',
	},
	NO: {
		ribbon: 'SALG',
		offerText: '19 kr./md.',
		longText: 'Supertilbud: 19 kr./måned',
		endDate: '2024-03-14',
	},
	SE: {
		ribbon: 'DEAL',
		offerText: '19 kr/mån',
		longText: '19 kr per mån i 3 månader',
		endDate: '2024-03-14',
	},
};

export const DisneyPlusId = 337 as const;

// Types just for fun
type digits = '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9';
type day = `${'0'}${Exclude<digits, '0'>}` | `${'1' | '2'}${digits}` | '30' | '31';
type month = `${'0'}${Exclude<digits, '0'>}` | '10' | '11' | '12';
type year = `20${digits}${digits}`;
type ISO8601 = `${year}-${month}-${day}`;

interface PromoTexts {
	/** Set `null` to disable. */
	ribbon: string | null;
	/** Set `null` to disable. */
	offerText: string | null;
	/** Set `null` to disable. */
	longText: string | null;
	/** `YYYY-MM-DD` format. */
	endDate: ISO8601;
}

export const getDisneyPromoText: (country: string, currentDate?: Date) => PromoTexts | null = (
	country,
	currentDate = new Date()
) => {
	if (!CountriesAvailable.includes(country as any)) return null;

	const promoText = PromotionTexts[country as DisneyPromoCountries];
	if (promoText.endDate && +currentDate > new Date(promoText.endDate).setUTCHours(23, 59, 59, 999)) return null;

	return promoText;
};
